<template>
  <v-autocomplete
    :loading="loading"
    :items="items"
    :search-input.sync="search"
    v-model="model"
    item-value="index"
    item-text="partner.name"
    return-object
    flat
    hide-no-data
    :hide-details="!errorMessages && !(rules && !!rules.length)"
    no-filter
    :label="label"
    :rules="rules"
    @input="changed"
    @dblclick.native="querySelections('?')"
    :error-messages="errorMessages"
  >
    <template slot="item" slot-scope="data">
      <template v-if="typeof data.item !== 'object'">
        <v-list-tile-content v-text="data.item"></v-list-tile-content>
      </template>
      <template v-else>
        <v-list-tile-avatar>
          <v-icon>{{ getItemType(data.item) }}</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title v-html="data.item.partner.name"></v-list-tile-title>
          <v-list-tile-sub-title v-html="displayAddress(data.item.address)"></v-list-tile-sub-title>
        </v-list-tile-content>
      </template>
    </template>
    <v-tooltip slot="append" bottom>
      <v-icon slot="activator" @click="showOwn = !showOwn">{{ showOwn ? 'supervisor_account' : 'import_contacts' }}</v-icon>
      <span>{{ $t(showOwn ? "Show my addresses" : "Show my contacts") }}</span>
    </v-tooltip>
  </v-autocomplete>
</template>

<script>
import { debounce } from "lodash";
import { suggest } from "../resources";
import { addressString } from "../components/util";

export default {
  name: "v-suggest-contact",
  props: ["label", "value", "rules", "own", "error-messages"],

  data() {
    return {
      loading: false,
      items: [],
      search: "",
      model: "",
      showOwn: this.own || false,
      amazonReference: false
    }
  },

  watch: {
    search(val, oldv) {
      // console.log("contactSuggest.search:watch("+val+"), was: " + oldv);
      this.suggest(val);
    },
    value(val) {
      let x = !!val && !!val.partner ? val.partner.code + ", " + val.partner.name : "N/A";
      // console.log("contactSuggest.value:watch("+ x + ")");
      this.init();
    },
    showOwn(val) {
      this.$emit("own-changed", val);
      this.querySelections(this.search);
    }
  },

  methods: {
    suggestImpl(val) {
      let same = !!this.model && !!this.model.partner ? val === this.model.partner.name : false;
      // console.log("contactSuggest.suggestImpl(" + val + "), same: " + same);
      val && !same && this.querySelections(val);
    },

    querySelections(q) {
      if (this.loading)
        return;

      // console.log("contactSuggest.querySelection(" + q + ")");
      if (q === "?")
        q = "";

      let//
      data = {
        partner: { name: q },
        own: this.showOwn
      };

      this.loading = true;
      suggest.suggestContact({}, data).then((result) => {
        if (result.body.result && result.body.result.length > 0)
        {
          this.items = result.body.result;
          // add search string as result with last index, no ID
          if (!this.showOwn && !this.items.find(e => e.partner && e.partner.name && q && q.toUpperCase() === e.partner.name.toUpperCase()))
            this.items.push({ partner: { code: null, name: q }, index: this.items.length });

          // fix: index used as unique item-value, not to hide items with same ID (code)
          this.items.forEach((elem, idx) => this.items[idx].index = idx);
        }
        else
        {
          console.log("Add default value in the result");
          this.items = new Array();
          this.items.push({ partner: { code: null, name: q } });
        }

        this.$emit("amazon-reference", !!result.body.amazon_reference);

      }).catch((err) => {
        console.log(err);
      }).finally(() => {
        this.loading = false;
      });
    },

    init() {
      // console.log("contactSuggest.init with the following data:");
      // console.log("Model", this.value);
      if (!!this.value && !!this.value.partner) {
        this.model = Object.assign( {}, this.value );
        this.items = new Array();
        this.items.push(this.model);
        this.search = this.value.partner.name;
      } else {
        console.log("null model");
      }
      // console.log(this.model.partner.code + ": " + this.model.partner.name);
    },

    changed() {
      this.$emit("clear-errors");

      let//
      s = Object.assign( {}, this.value );
      if (this.model) {
        s = Object.assign( s, this.model );
        if (this.model.address)
        {
          s.address = Object.assign( s.address, this.model.address );
          if (this.model.address.settlement)
            s.address.settlement = Object.assign( s.address.settlement, this.model.address.settlement );
        }
        if (this.model.partner)
        {
          s.partner = Object.assign( s.partner, this.model.partner );
        }
      } else {
        s.partner = { code: null, name: "" };
      }
      // clean-up helper data
      if (!!s.index || s.index == 0)
        delete s.index;
      // console.log("Emitting change", s);
      this.$emit("input", s);
    },

    displayAddress(a) {
      let t = {
        block: this.$t("block"),
        floor: this.$t("floor"),
        entrance: this.$t("entrance"),
        apartment: this.$t("apartment")
      };

      let d = addressString(a, t);
      return d.address;
    },

    getItemType(item) {
      if (item && item.address_info)
      {
        if (item.address_info.type === "connection")
          return "list";
        if (item.address_info.type === "business_address")
          return "outlined_flag";
        return "graphic_eq";
      }
      return "insert_link";
    }
  },

  created() {
    this.suggest = debounce(this.suggestImpl, 500);
  },

  mounted() {
    // console.log('contactSuggester.mounted');
    this.init();
  }
}
</script>